import { NonClosableBackdrop } from 'utils/modalBehavior';

export default function Drawer() {
  return {
    MuiDrawer: {
      defaultProps: {
        ModalProps: {
          disableEscapeKeyDown: true,
          slots: {
            backdrop: NonClosableBackdrop
          }
        }
      }
    }
  };
}